import * as i0 from '@angular/core';
import { EventEmitter, ViewContainerRef, TemplateRef, Component, ViewChild, Input, Output, NgModule } from '@angular/core';
import * as i1 from 'abs-ngx-library/src/lib/core';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';

const _c0 = ["sortDropdownItemContainer"];
const _c1 = ["themeBuilderEnabledTemplate"];
const _c2 = ["defaultTemplate"];
const _c3 = ["DSTV2Template"];
const _c4 = ["sortId"];
const _c5 = a0 => ({ "dropdown-item": true, "filter-selected-link": a0 });
const _c6 = a0 => ({ "sort-ui__dropdown-anchor": true, "dropdown-item": true, "filter-selected-link": a0 });
function SortAlV1Component_ng_template_2_li_11_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 14)(1, "a", 15);
    i0.ɵɵlistener("click", function SortAlV1Component_ng_template_2_li_11_Template_a_click_1_listener() { const sortRule_r2 = i0.ɵɵrestoreView(_r1).$implicit; const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.doSortEmitter(sortRule_r2)); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const sortRule_r2 = ctx.$implicit;
    const i_r4 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "sortRule-", i_r4, "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c5, ctx_r2.activeSortRule && ctx_r2.activeSortRule.label == sortRule_r2.label));
    i0.ɵɵattribute("aria-current", sortRule_r2.selected ? true : null)("aria-label", sortRule_r2.label);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(sortRule_r2.label);
} }
function SortAlV1Component_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5, 4)(2, "div", 6)(3, "button", 7)(4, "p", 8)(5, "span", 9);
    i0.ɵɵtext(6, "Sort ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "span", 10);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(9, "span", 11);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "ul", 12);
    i0.ɵɵtemplate(11, SortAlV1Component_ng_template_2_li_11_Template, 3, 8, "li", 13);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵattributeInterpolate1("aria-activedescendent", "sortRule-", ctx_r2.selectedSortRuleIndex, "");
    i0.ɵɵattribute("aria-expanded", ctx_r2.arriaExpanded)("data-active-id", ctx_r2.selectedSortRuleIndex);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1("\u00A0(", ctx_r2.activeSortRule ? ctx_r2.activeSortRule.label : "", ")");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r2.sortRules);
} }
function SortAlV1Component_ng_template_4_li_10_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 24)(1, "a", 15);
    i0.ɵɵlistener("click", function SortAlV1Component_ng_template_4_li_10_Template_a_click_1_listener() { const sortRule_r6 = i0.ɵɵrestoreView(_r5).$implicit; const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.doSortEmitter(sortRule_r6)); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const sortRule_r6 = ctx.$implicit;
    const i_r7 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "sortRule-", i_r7, "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c6, ctx_r2.activeSortRule && ctx_r2.activeSortRule.label == sortRule_r6.label));
    i0.ɵɵattribute("aria-current", sortRule_r6.selected ? true : null)("aria-label", sortRule_r6.label);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(sortRule_r6.label);
} }
function SortAlV1Component_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16, 4)(2, "button", 17)(3, "p", 18)(4, "span", 19);
    i0.ɵɵtext(5, "Sort by ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "span", 20);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(8, "span", 21);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(9, "ul", 22);
    i0.ɵɵtemplate(10, SortAlV1Component_ng_template_4_li_10_Template, 3, 8, "li", 23);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵattributeInterpolate1("aria-activedescendent", "sortRule-", ctx_r2.selectedSortRuleIndex, "");
    i0.ɵɵattribute("aria-expanded", ctx_r2.arriaExpanded)("data-active-id", ctx_r2.selectedSortRuleIndex);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1("\u00A0", ctx_r2.activeSortRule ? ctx_r2.activeSortRule.label : "", "");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r2.sortRules);
} }
function SortAlV1Component_ng_template_6_li_9_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 14)(1, "a", 30);
    i0.ɵɵlistener("click", function SortAlV1Component_ng_template_6_li_9_Template_a_click_1_listener() { const sortRule_r9 = i0.ɵɵrestoreView(_r8).$implicit; const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.doSortEmitter(sortRule_r9)); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const sortRule_r9 = ctx.$implicit;
    const i_r10 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵattributeInterpolate3("aria-label", "", sortRule_r9.label, " ", i_r10 + 1, " of ", ctx_r2.sortRules == null ? null : ctx_r2.sortRules.length, "");
    i0.ɵɵpropertyInterpolate1("id", "sortRule-", i_r10, "");
    i0.ɵɵattribute("aria-current", sortRule_r9.selected ? true : null);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(sortRule_r9.label);
} }
function SortAlV1Component_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25, 4)(2, "div", 26)(3, "button", 27)(4, "span", 9);
    i0.ɵɵtext(5, "Sort by ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "span", 28);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "ul", 29);
    i0.ɵɵtemplate(9, SortAlV1Component_ng_template_6_li_9_Template, 3, 8, "li", 13);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵattributeInterpolate1("aria-activedescendent", "sortRule-", ctx_r2.selectedSortRuleIndex, "");
    i0.ɵɵattribute("aria-expanded", ctx_r2.arriaExpanded)("data-active-id", ctx_r2.selectedSortRuleIndex);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("\u00A0", ctx_r2.activeSortRule ? ctx_r2.activeSortRule.label : "", "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r2.sortRules);
} }
function _window() {
    return window;
}
class SortAlV1Component {
    constructor(rd, _commonService) {
        this.rd = rd;
        this._commonService = _commonService;
        this.activeSortRuleEmitter = new EventEmitter();
        this.arriaExpanded = false;
        this.defaultSorted = false;
        /* Sort by, Angular dropdown component ARIA , Taken from ARIA.JS*/
        this.sortByComponent = function () {
            const sortBy = $('.dropdown-sort-by.dropdown');
            const sortByButton = sortBy.find('#sortByID');
            $('.sort-by-text').focusout(function () {
                $(this).css('outline', 'none');
            });
            /* aria-expanded removed when dropdown list is hidden + focus changing*/
            sortBy.on('hidden.bs.dropdown', function (e) {
                e.preventDefault();
                setTimeout(function () {
                    $('#sortByID').focus();
                }, 300);
            });
            // to add the showPromo class for filters in mobile view
            if ($('div.cfh-banner.cfh-banner__search').length > 0) {
                $('#filterMV').addClass('showPromo');
            }
            $(document).not('.squaredThree').on('click', 'label', function (e) {
                $(this).css('outline', 'none');
            });
            $('.label-more').on('click', function (e) {
                $(this).prev().children(':eq(5)').children('label').css('outline', 'none');
            });
        };
        this.isThemeBuilderEnabled = _window().SWY.CONFIGSERVICE.isThemeBuilderEnabled;
        this.enableDstV2Theme = this._commonService.hasPageV2Theme();
    }
    doSortEmitter(activeSortRule) {
        this.activeSortRule = activeSortRule;
        this.activeSortRuleEmitter.emit(this.activeSortRule);
        // update datalayer
        if (window['AB']['DATALAYER'] && this.activeSortRule && this.activeSortRule.label) {
            window['AB']['DATALAYER'].sortBy(this.activeSortRule.label);
        }
    }
    /**
     * Triggered on properties changes - Search and update new active sort rule index
     *
     * @param {SimpleChanges} changes properties that has been changed
     */
    ngOnChanges(changes) {
        if (changes.activeSortRule) {
            this.sortRules.forEach((sort, i) => {
                if (this.activeSortRule && sort.field === this.activeSortRule.field) {
                    this.selectedSortRuleIndex = i;
                    sort.selected = true;
                    this.defaultSorted = true;
                }
                else {
                    sort.selected = null;
                }
            });
        }
    }
    /**
     * Call Accessibility ARIA methods
     */
    ngAfterViewInit() {
        this.sortByComponent();
        //README: Code is not currently used commenting for now 
        // if (!this.el.nativeElement) {
        //     console.log('sortID NO detected');
        // } else {
        //     console.log('sortID YES detected');
        //     this.el.nativeElement.style.background = 'white';
        //     this.el.nativeElement.style.border = '0px solid';
        // }
    }
    ngOnInit() {
        this.loadSortDropdownItemContainer();
    }
    loadSortDropdownItemContainer() {
        switch (true) {
            case this.enableDstV2Theme:
                this.sortDropdownItemContainer.createEmbeddedView(this.DSTV2Template);
                break;
            case this.isThemeBuilderEnabled:
                this.sortDropdownItemContainer.createEmbeddedView(this.themeBuilderEnabledTemplate);
                break;
            default:
                this.sortDropdownItemContainer.createEmbeddedView(this.defaultTemplate);
                break;
        }
    }
    removeVowels(option) {
        return option.toLowerCase().replace(/ /g, '').replace(/[aeiou]/g, '');
    }
    static { this.ɵfac = function SortAlV1Component_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SortAlV1Component)(i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i1.CommonService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SortAlV1Component, selectors: [["sort-by"]], viewQuery: function SortAlV1Component_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 7, ViewContainerRef);
            i0.ɵɵviewQuery(_c1, 7, TemplateRef);
            i0.ɵɵviewQuery(_c2, 7, TemplateRef);
            i0.ɵɵviewQuery(_c3, 7, TemplateRef);
            i0.ɵɵviewQuery(_c4, 7);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sortDropdownItemContainer = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.themeBuilderEnabledTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.defaultTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.DSTV2Template = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.el = _t.first);
        } }, inputs: { sortRules: "sortRules", activeSortRule: "activeSortRule" }, outputs: { activeSortRuleEmitter: "activeSortRuleEmitter" }, features: [i0.ɵɵNgOnChangesFeature], decls: 8, vars: 0, consts: [["sortDropdownItemContainer", ""], ["defaultTemplate", ""], ["themeBuilderEnabledTemplate", ""], ["DSTV2Template", ""], ["sortId", ""], ["role", "region", "aria-label", "Sort by", 1, "sort-by-wrapper", "card"], [1, "dropdown", "dropdown-sort-by", "card-header"], ["type", "button", "id", "sortByID", "data-toggle", "dropdown", "aria-haspopup", "true", "data-qa", "srt-ptns-dflt"], [1, "sort-by-text"], [1, "float-left"], [1, "d-none", "d-lg-block", "float-left"], [1, "svg-icon", "svg-icon-sort-by-caret", "svg-icon-Arrow_down_black"], ["aria-labelledby", "sortByID", "role", "menu", 1, "dropdown-menu", "card-body", "dropdown-menu-sort-mobile"], ["role", "none", 4, "ngFor", "ngForOf"], ["role", "none"], ["href", "#", "onClick", "return false;", "role", "menuitem", "tabindex", "-1", "data-qa", "srt-ptns", 3, "click", "ngClass", "id"], ["role", "region", "aria-label", "Sort by", 1, "sort-ui", "dropdown", "dropdown-sort-by"], ["type", "button", "id", "sortByID", "data-toggle", "dropdown", "aria-haspopup", "true", "data-qa", "srt-ptns-dflt", 1, "sort-ui__sort-btn"], [1, "sort-ui__text-container"], [1, "sort-ui__default-text"], [1, "sort-ui__strategy", "d-none", "d-lg-inline-block"], [1, "sort-ui__icon", "svg-caret-down"], ["aria-labelledby", "sortByID", "role", "menu", 1, "sort-ui__dropdown", "dropdown-menu", "dropdown-menu-sort-mobile"], ["role", "none", "class", "sort-ui__dropdown-item", 4, "ngFor", "ngForOf"], ["role", "none", 1, "sort-ui__dropdown-item"], [1, "sort-by-wrapper", "card"], [1, "dropdown", "sort-dropdown"], ["type", "button", "id", "sortDropdown", "data-toggle", "dropdown", "role", "button", "aria-haspopup", "true", "aria-controls", "sortDropdownMenu", "data-qa", "srt-ptns-dflt", 1, "btn", "btn-secondary", "sort-dropdown__btn"], [1, "d-lg-block", "float-left"], ["id", "sortDropdownMenu", "role", "menu", "aria-label", "Sort", 1, "dropdown-menu", "sort-dropdown__wrapper"], ["role", "menuitem", "tabindex", "-1", "href", "javascript:void(0);", "data-qa", "srt-ptns", 1, "dropdown-item", 3, "click", "id"]], template: function SortAlV1Component_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementContainer(0, null, 0);
            i0.ɵɵtemplate(2, SortAlV1Component_ng_template_2_Template, 12, 6, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(4, SortAlV1Component_ng_template_4_Template, 11, 6, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(6, SortAlV1Component_ng_template_6_Template, 10, 6, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
        } }, dependencies: [i2.NgClass, i2.NgForOf], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SortAlV1Component, [{
        type: Component,
        args: [{ selector: 'sort-by', template: "<ng-container #sortDropdownItemContainer></ng-container>\n\n<ng-template #defaultTemplate>\n    <div #sortId class=\"sort-by-wrapper card\" role=\"region\" aria-label=\"Sort by\">\n        <div class=\"dropdown dropdown-sort-by card-header\">\n\n            <button type=\"button\"\n                id=\"sortByID\"\n                data-toggle=\"dropdown\"\n                aria-haspopup=\"true\"\n                [attr.aria-expanded]=\"arriaExpanded\"\n                attr.data-active-id=\"{{selectedSortRuleIndex}}\"\n                attr.aria-activedescendent=\"sortRule-{{selectedSortRuleIndex}}\"\n                data-qa=\"srt-ptns-dflt\">\n\n                <p class=\"sort-by-text\">\n                    <span class=\"float-left\">Sort </span>\n                    <span class=\"d-none d-lg-block float-left\">&nbsp;({{activeSortRule ? activeSortRule.label : ''}})</span>\n                    <span class=\"svg-icon svg-icon-sort-by-caret svg-icon-Arrow_down_black\"></span>\n                </p>\n            </button>\n\n            <ul class=\"dropdown-menu card-body dropdown-menu-sort-mobile\" aria-labelledby=\"sortByID\" role=\"menu\">\n                <li *ngFor=\"let sortRule of sortRules; let i = index\" role=\"none\">\n                    <a [ngClass]=\"{'dropdown-item': true, 'filter-selected-link': activeSortRule && activeSortRule.label == sortRule.label}\"\n                    id=\"sortRule-{{i}}\"\n                    (click)=\"doSortEmitter(sortRule)\"\n                    href=\"#\"\n                    [attr.aria-current]=\"sortRule.selected ? true : null\"\n                    onClick=\"return false;\" role=\"menuitem\" tabindex=\"-1\" attr.aria-label=\"{{sortRule.label}}\" data-qa=\"srt-ptns\">{{sortRule.label}}</a>\n                </li>\n            </ul>\n        </div>\n    </div>\n</ng-template>\n\n\n<ng-template #themeBuilderEnabledTemplate>\n    <div #sortId class=\"sort-ui dropdown dropdown-sort-by\" role=\"region\" aria-label=\"Sort by\">\n        <button type=\"button\"\n            id=\"sortByID\"\n            class=\"sort-ui__sort-btn\"\n            data-toggle=\"dropdown\"\n            aria-haspopup=\"true\"\n            [attr.aria-expanded]=\"arriaExpanded\"\n            attr.data-active-id=\"{{selectedSortRuleIndex}}\"\n            attr.aria-activedescendent=\"sortRule-{{selectedSortRuleIndex}}\"\n            data-qa=\"srt-ptns-dflt\">\n\n            <p class=\"sort-ui__text-container\">\n                <span class=\"sort-ui__default-text\">Sort by </span>\n                <span class=\"sort-ui__strategy d-none d-lg-inline-block\">&nbsp;{{activeSortRule ? activeSortRule.label : ''}}</span>\n                <span class=\"sort-ui__icon svg-caret-down\"></span>\n            </p>\n        </button>\n\n        <ul class=\"sort-ui__dropdown dropdown-menu dropdown-menu-sort-mobile\" aria-labelledby=\"sortByID\" role=\"menu\">\n            <li *ngFor=\"let sortRule of sortRules; let i = index\" role=\"none\" class=\"sort-ui__dropdown-item\">\n                <a [ngClass]=\"{'sort-ui__dropdown-anchor': true, 'dropdown-item': true, 'filter-selected-link': activeSortRule && activeSortRule.label == sortRule.label}\"\n                    id=\"sortRule-{{i}}\"\n                    (click)=\"doSortEmitter(sortRule)\"\n                    href=\"#\"\n                    [attr.aria-current]=\"sortRule.selected ? true : null\"\n                    onClick=\"return false;\" role=\"menuitem\" tabindex=\"-1\" attr.aria-label=\"{{sortRule.label}}\"\n                    data-qa=\"srt-ptns\">{{sortRule.label}}</a>\n            </li>\n        </ul>\n    </div>\n</ng-template>\n\n\n<ng-template #DSTV2Template>\n    <div #sortId class=\"sort-by-wrapper card\">\n        <div class=\"dropdown sort-dropdown\">\n\n            <button type=\"button\"\n                class=\"btn btn-secondary sort-dropdown__btn\"\n                id=\"sortDropdown\"\n                data-toggle=\"dropdown\"\n                role=\"button\"\n                aria-haspopup=\"true\"\n                [attr.aria-expanded]=\"arriaExpanded\"\n                attr.data-active-id=\"{{selectedSortRuleIndex}}\"\n                attr.aria-activedescendent=\"sortRule-{{selectedSortRuleIndex}}\"\n                aria-controls=\"sortDropdownMenu\"\n                data-qa=\"srt-ptns-dflt\">\n                <span class=\"float-left\">Sort by </span>\n                <span class=\"d-lg-block float-left\">&nbsp;{{activeSortRule ? activeSortRule.label : ''}}</span>\n            </button>\n        \n            <ul id=\"sortDropdownMenu\" role=\"menu\" class=\"dropdown-menu sort-dropdown__wrapper\" aria-label=\"Sort\">\n                <li role=\"none\" *ngFor=\"let sortRule of sortRules; let i = index\">\n                    <a role=\"menuitem\" tabindex=\"-1\" class=\"dropdown-item\" (click)=\"doSortEmitter(sortRule)\" \n                        id=\"sortRule-{{i}}\"href=\"javascript:void(0);\" [attr.aria-current]=\"sortRule.selected ? true : null\" attr.aria-label=\"{{sortRule.label}} {{i + 1}} of {{sortRules?.length}}\" \n                            data-qa=\"srt-ptns\">{{sortRule.label}}</a>\n                </li>\n            </ul>\n        </div>\n    </div>\n</ng-template>" }]
    }], () => [{ type: i0.Renderer2 }, { type: i1.CommonService }], { sortDropdownItemContainer: [{
            type: ViewChild,
            args: ['sortDropdownItemContainer', { read: ViewContainerRef, static: true }]
        }], themeBuilderEnabledTemplate: [{
            type: ViewChild,
            args: ['themeBuilderEnabledTemplate', { read: TemplateRef, static: true }]
        }], defaultTemplate: [{
            type: ViewChild,
            args: ['defaultTemplate', { read: TemplateRef, static: true }]
        }], DSTV2Template: [{
            type: ViewChild,
            args: ['DSTV2Template', { read: TemplateRef, static: true }]
        }], sortRules: [{
            type: Input
        }], activeSortRule: [{
            type: Input
        }], activeSortRuleEmitter: [{
            type: Output
        }], el: [{
            type: ViewChild,
            args: ['sortId', { static: true }]
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(SortAlV1Component, { className: "SortAlV1Component", filePath: "sort-by-al-v1.component.ts", lineNumber: 29 }); })();

class SortByAlV1Module {
    static { this.ɵfac = function SortByAlV1Module_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SortByAlV1Module)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: SortByAlV1Module }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SortByAlV1Module, [{
        type: NgModule,
        args: [{
                declarations: [SortAlV1Component],
                exports: [
                    SortAlV1Component,
                ],
                imports: [
                    CommonModule,
                ],
                providers: []
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(SortByAlV1Module, { declarations: [SortAlV1Component], imports: [CommonModule], exports: [SortAlV1Component] }); })();

// //Component

/**
 * Generated bundle index. Do not edit.
 */

export { SortAlV1Component, SortByAlV1Module };
